// extracted by mini-css-extract-plugin
export default {"edit_your_box":"Kl","edit_box_title":"Ll","subscription":"Ml","byb":"Nl","recommended_for_you_title":"Ol","explore":"Pl","recommended":"Ql","go_back":"Rl","wrapper":"Sl","product_img":"Tl","info":"Ul","remove_btn":"Vl"};
    if(module.hot) {
      // 1738064236098
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  